// experienceQueryKey.ts

/**
 * Stable React Query key for a single Experience record.
 *
 * Since Experiences are fetched individually (not as a collection),
 * the cache key only needs the experienceId.
 */
export const experienceQueryKey = (experienceId?: string) => ['userExperience', experienceId ? Number(experienceId) : 'new'];
